import * as React from 'react';
import { Card } from 'shared/components/Card';
import { Typography } from 'shared/components/Typography';
import { Skeleton } from 'shared/components/Skeleton';
import { ThicknessItemPlaceholder } from '../components/ThicknessItem/Placeholder';
import styles from './index.module.scss';

const PaintThicknessPlaceholder = () => (
  <Card
    externalStyle={styles.container}
    qaIdPrefix="paint-thickness-loader"
    showBottomBorder
  >
    <Typography variant="titleXL" tag="div" additonalClassNames={styles.title}>
      <Skeleton width="161px" height="100%" />
    </Typography>
    <Typography tag="div">
      <Skeleton width="161px" height="100%" />
    </Typography>
    <div className={styles.grid}>
      {new Array(5).fill(null).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <ThicknessItemPlaceholder key={index} />
      ))}
    </div>
  </Card>
);

export { PaintThicknessPlaceholder };
